import { BeneficiaryTimeSeriesDimension } from '@repo/shared/dtos/beneficiary'
import { useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { Label } from '@repo/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/select'

export default function TimeSeriesDateBuckets({
  dimension,
  onChange,
}: {
  dimension: BeneficiaryTimeSeriesDimension
  onChange: (dimension: BeneficiaryTimeSeriesDimension) => void
}) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.dimensions.buckets.date.timeSeries' })

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t('groupBy')}</Label>
        <Select
          value={dimension.timeSeries?.groupBy ?? 'day'}
          onValueChange={(value) =>
            onChange({
              ...dimension,
              timeSeries: {
                ...dimension.timeSeries,
                groupBy: value as BeneficiaryTimeSeriesDimension['timeSeries']['groupBy'],
              },
            })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder={t('groupByPlaceholder')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="day">{t('groupByOptions.day')}</SelectItem>
            <SelectItem value="week">{t('groupByOptions.week')}</SelectItem>
            <SelectItem value="month">{t('groupByOptions.month')}</SelectItem>
            <SelectItem value="year">{t('groupByOptions.year')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-row gap-2">
        <div className="space-y-2">
          <Label>{t('range')}</Label>
          <Select
            value={dimension.timeSeries?.range?.unit ?? 'day'}
            onValueChange={(value) =>
              onChange({
                ...dimension,
                timeSeries: {
                  ...dimension.timeSeries,
                  range: {
                    unit: value as BeneficiaryTimeSeriesDimension['timeSeries']['range']['unit'],
                    value: dimension.timeSeries?.range?.value ?? 1,
                  },
                },
              })
            }
          >
            <SelectTrigger>
              <SelectValue placeholder={t('rangePlaceholder')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="day">{t('rangeOptions.day')}</SelectItem>
              <SelectItem value="week">{t('rangeOptions.week')}</SelectItem>
              <SelectItem value="month">{t('rangeOptions.month')}</SelectItem>
              <SelectItem value="year">{t('rangeOptions.year')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>{t('rangeValue')}</Label>
          <Input
            type="number"
            min={1}
            value={dimension.timeSeries?.range?.value ?? 1}
            onChange={(event) =>
              onChange({
                ...dimension,
                timeSeries: {
                  ...dimension.timeSeries,
                  range: {
                    unit: dimension.timeSeries?.range?.unit ?? 'day',
                    value: parseInt(event.target.value),
                  },
                },
              })
            }
          />
        </div>
      </div>
    </div>
  )
}
